/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function chooseVideo(options, context) {
    // 钉钉小程序 ref: https://open.dingtalk.com/document/orgapp/dd-choosevideo
    context === null || context === void 0 ? void 0 : context.PanguMiniAppCall('chooseVideo', options);
}

export { chooseVideo as default };
